import { orchestrator, mutatorAction } from 'satcheljs';
import {
    onTimeStreamAssetCreated,
    deleteAssets,
    getSelectedProjectId,
    setPoliteAnnouncement,
    setProjectInLocalStorage,
} from 'owa-timestream-store';
import { setCanvasLock } from 'owa-timestream-asset-sdk-actions';
import { dropAssetIntoBucket, removeAssetFromBucket } from 'owa-timestream-asset-sdk-bucket';
import { showResizeHandles } from 'owa-timestream-asset-sdk-resize';
import isCanvasLockEnabled from '../selectors/isCanvasLockEnabled';
import isCanvasLocked from '../selectors/isCanvasLocked';
import getStore from '../store';
import loc from 'owa-localize';
import {
    canvasUnlockedAnnouncement,
    canvasLockedAnnouncement,
} from './CanvasLockAnnouncements.locstring.json';

orchestrator(setCanvasLock, ({ shouldLockCanvas }) => setLockAndAnnounce(shouldLockCanvas));

// unlock canvas on widget creation & deletion
orchestrator(onTimeStreamAssetCreated, unlockAndAnnounce);
orchestrator(deleteAssets, unlockAndAnnounce);

// unlock canvas on resize via contextual menu
orchestrator(showResizeHandles, unlockAndAnnounce);

// unlock canvas on widget addition/removal from bucket
orchestrator(dropAssetIntoBucket, unlockAndAnnounce);
orchestrator(removeAssetFromBucket, unlockAndAnnounce);

function unlockAndAnnounce() {
    setLockAndAnnounce(false);
}

function setLockAndAnnounce(shouldLockCanvas: boolean): void {
    if (isCanvasLockEnabled() && isCanvasLocked() !== shouldLockCanvas) {
        setLock(shouldLockCanvas);
        setProjectInLocalStorage(getSelectedProjectId(), { isCanvasLocked: shouldLockCanvas });

        setPoliteAnnouncement(
            shouldLockCanvas ? loc(canvasLockedAnnouncement) : loc(canvasUnlockedAnnouncement)
        );
    }
}

const setLock = mutatorAction('setLock', (shouldLockCanvas: boolean) => {
    getStore().isLocked = shouldLockCanvas;
});
